/**
 * cwear-editorial-hero.js
 *
 * Only loaded on product pages (see cwear-editorial-hero.liquid). Drives the
 * "smart" primary CTA: hidden unless the customer has a valid, in-stock
 * size+color combo selected in cwear-pdp-main — which is a SEPARATE section
 * with no shared DOM, so the two talk via a custom event
 * (cwear:pdp:variant-change, dispatched from cwear-pdp-main.js/updateButton).
 *
 * Click behavior: adds the selected variant to the cart via AJAX, then
 * redirects straight to /checkout (persuade-to-buy, not just add-to-cart).
 *
 * IIFE + section.id scoping, no ES6+, matches the rest of the theme's JS.
 */
(function () {
  'use strict';

  function initCta(root) {
    var btn = root.querySelector('button[id^="cwear-editorial-cta-"]');
    if (!btn) return;

    /* Estado inicial: cwear-pdp-main.js dispara su primer evento durante su
       propia ejecución síncrona, que en la página corre ANTES de que este
       script (defer) llegue a adjuntar el listener — así que el primer
       evento real se pierde. El estado inicial (oculto/visible + variant id)
       ya viene resuelto por el server en el HTML (ver liquid), así que se
       toma de ahí en vez de depender del evento para el primer render. */
    var currentVariant = null;
    var initialVariantId = parseInt(btn.getAttribute('data-variant-id'), 10);
    if (!btn.hidden && !isNaN(initialVariantId)) {
      currentVariant = { id: initialVariantId, available: true };
    }

    var isSubmitting = false;

    document.addEventListener('cwear:pdp:variant-change', function (evt) {
      if (!evt || !evt.detail) return;
      var variant = evt.detail.variant;
      var available = !!evt.detail.available;

      if (variant && available) {
        currentVariant = variant;
        btn.hidden = false;
      } else {
        currentVariant = null;
        btn.hidden = true;
      }
    });

    btn.addEventListener('click', function () {
      if (isSubmitting || !currentVariant) return;
      isSubmitting = true;
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ items: [{ id: currentVariant.id, quantity: 1 }] })
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (err) {
              throw new Error((err && err.description) || 'No se pudo agregar al carrito');
            });
          }
          return response.json();
        })
        .then(function () {
          window.location.href = '/checkout';
        })
        .catch(function () {
          /* Silencioso a propósito — es un CTA secundario/persuasivo, no el
             flujo principal de compra (que ya tiene su propio manejo de
             errores en cwear-pdp-main). Solo se rehabilita el botón. */
          isSubmitting = false;
          btn.disabled = false;
        });
    });
  }

  var roots = document.querySelectorAll('[id^="cwear-editorial-hero-"]');
  for (var i = 0; i < roots.length; i++) {
    initCta(roots[i]);
  }
})();
